import { useProjectsQuery } from 'src/queries';
import { useProjectFilesQuery } from 'src/queries/useFilesQuery';
import { filesService } from 'src/api/services';
import type { FileRecord } from 'src/api/services/files';
import './FileList.css';

const FileList = () => {
  const { data: projects = [] } = useProjectsQuery();

  return (
    <div className="file-list-container">
      {projects.map((project) => (
        <div className="project-file-section" key={project.id}>
          <h5>{project.name}</h5>
          <ProjectFileList projectId={project.id} />
        </div>
      ))}
    </div>
  );
};

const ProjectFileList = ({ projectId }: { projectId: string }) => {
  const { data: files = [], isLoading } = useProjectFilesQuery(projectId);

  if (isLoading) return <p>Loading files...</p>;
  if (files.length === 0) return <p>No files uploaded yet</p>;

  return (
    <div className="file-list-container">
      {files.map((file: FileRecord) => (
        <div
          className="file-item"
          key={file.id}
          onClick={() => void handleDownload(file)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              void handleDownload(file);
            }
          }}
          role="button"
          tabIndex={0}
        >
          <span className="file-name">{file.original_filename}</span>
          <span className="file-size">({formatFileSize(file.size_bytes)})</span>
          <button
            className="open-button"
            onClick={(e) => {
              e.stopPropagation();
              void handleDownload(file);
            }}
          >
            Download
          </button>
        </div>
      ))}
    </div>
  );
};

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const handleDownload = async (file: FileRecord) => {
  try {
    const blob = await filesService.download(file.id);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.original_filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  } catch (error) {
    if (import.meta.env.DEV) {
      console.error('Error downloading file:', error);
    }
    alert('Error downloading file. Please contact service@protectum.com and report this error.');
  }
};

export default FileList;
